import OLScaleLine from 'ol/control/ScaleLine'

import * as Model from 'api/model'
import IsSmallScreen, { MEDIUM_SCREEN_PIXELS } from 'utils/IsSmallScreen'

const AddScaleLine = (map) => {
  const bAddScaleControl = Model.get('config.settings.map.controls.scale.visible', true) // This is set in templates.json
  if (!bAddScaleControl) {
    return
  }

  const screenWidth = window.innerWidth

  // Make sure that the scale line is not too large on small screens: we limit it to about 1/3
  // of the screen width on large screens, and to about 1/2 of the screen width on smaller screens
  let maxWidth = Math.min(screenWidth / 3, 400)
  let minWidth = Math.min(screenWidth / 3, 250, maxWidth)
  if (IsSmallScreen(MEDIUM_SCREEN_PIXELS)) {
    maxWidth = Math.max((screenWidth / 2) - 10, minWidth)
    minWidth = Math.min((screenWidth / 2), maxWidth)
  }

  // console.debug('AddScaleLine', minWidth, maxWidth, screenWidth)

  const control = new OLScaleLine({
    bar: true,
    maxWidth,
    minWidth,
    steps: 4,
    text: true,
    units: 'metric'
  })

  map.addControl(control)
}

export default AddScaleLine
